import { hasValue } from './typeguards.utils';
export const getTextPxWidth = (text, style, weight, size) => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (context && hasValue(text)) {
        context.font = `${style ?? 'normal'} ${weight ?? 500} ${size ?? '16px'} AvenirNext`;
        return context.measureText(text).width;
    }
    else {
        return 0;
    }
};
/** Calculate how many elements can have a container in one line **/
export const getMaxAmountElementsInContainer = (containerWidth, texts, textOffset, textMaxWidth, moreButtonWidth) => {
    let amount = 0;
    let usedPx = 0;
    for (let i = 0; i < texts.length; i++) {
        const textWidth = getTextPxWidth(texts[i]);
        const targetTextWidth = textWidth > textMaxWidth ? textMaxWidth : textWidth;
        const elementWidth = targetTextWidth + textOffset;
        // Don't add more button width for last item
        const isLastText = i === texts.length - 1;
        const elementWidthWithMore = isLastText ? elementWidth : elementWidth + moreButtonWidth;
        if (containerWidth >= usedPx + elementWidthWithMore) {
            usedPx = usedPx + elementWidth;
            amount = amount + 1;
        }
        else {
            break;
        }
    }
    return amount;
};
//# sourceMappingURL=dom.utils.js.map